"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/** Read-only card for the Concur itemization WRITE tool. Keyed by bare tool name. */
export const concurItemizationWriteToolRegistry = {
  concurAddItemization: {
    kind: "standalone",
    category: "create",
    view: lazy(() =>
      import("./itemization-write-views").then(
        ({ ConcurAddItemizationToolView }) => ({
          default: ConcurAddItemizationToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
